export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10079.72a1505f.jpg";